import * as React from 'react';
import { PdsIconHeart as PdsIconHeartElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconHeart = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-heart',
  elementClass: PdsIconHeartElement,
  react: React,
});
